export default __webpack_public_path__ + "static/eds-map-4-bc1dd93d7167fe9a6930be04d6ae4028.gif";